import React from 'react';
import { Link } from 'react-router-dom';
import ContactSection from '../components/sections/ContactSection';
import './PageLayout.css';

const SocialsPage = () => {
  return (
    <div className="page-layout">
      <Link to="/" className="back-button">← Home</Link>
      <div className="page-content">
        <ContactSection />
      </div>
    </div>
  );
};

export default SocialsPage;

